import { DrMaxProductsInStock } from '../../../graphql/graphql';

const isAllInStock = (items: DrMaxProductsInStock[]) => {
	return items.every(item => item.inStock);
};

export { isAllInStock };
